import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          ConcertSliderItem,
          HomeTitle         } from '../../Components/UI/UI'

import {  showsArr } from "../../Data/Data";
import { compareDates, getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./LiveShows.css"

class LiveShows extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}

  render(){
    let counter = 0;
    let counter2 = 0;
    let hasBean = [];
    const  date1 = new Date();
    const concertSHtml = showsArr.map( (o,i) => {
        let cssClass="newAddOpacity";
        let html ="";
        if ( counter % 4 === 0 ) {
          cssClass ="first newAddOpacity";
        }

        if ( o.isDouble === true){
          cssClass ="double-singer newAddOpacity";
        }

        const isTodayBigger = compareDates(date1, o.date);
        if ( isTodayBigger === true  || o.date === "30.12.2017" || o.date === "21.06.2018") {
          cssClass +=" addOpacity ";
          hasBean.push(o);
        }else {

          counter++
          const url = "/Posts/Concerts/" + o.id ;
          if ( url === "/Posts/Concerts/undefined"){
            cssClass ="no-inner-page newAddOpacity";
          }
          // if (o.title === "UNITE WITH TOMORROWLAND")

        
            return <ConcertSliderItem
                  key={i}  
                  title={o.title}
                  desc={o.date}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass}
                   />
          
          

        }

    });



    // remove unnaccery shows
    hasBean.splice(-3,hasBean.length % 4  + 1);
    // hasBean.splice(-1,1);
    // hasBean.splice(-1,1);
    const hasBeanSHtml = hasBean.map( (o,i) => {
        let cssClass="newAddOpacity";
        let html ="";
        if ( counter2 % 4 === 0 ) {
          cssClass =" ";
        }

        cssClass +=" addOpacity newAddOpacity";
        counter2++
          const url = "/Posts/Concerts/" + o.id ;
          // if (o.title === "UNITE WITH TOMORROWLAND")
          return <ConcertSliderItem
                  key={i}  
                  title={o.title}
                  desc={o.date}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass} />

        

    });

    return(
      <div className="inner-page align-center page-LiveShows">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              LIVE INTERNATIONAL SHOWS & EVENTS 
            </HomeTitle>
            <div className="live-shows-wrapper">
              {concertSHtml}
              
              {hasBeanSHtml}
              <div className="clear"></div> 
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default LiveShows


// WEBPACK FOOTER //
// ./src/Pages/LiveShows/LiveShows.js